export const handleSelectPermissionFunction = (setPermission, value) => {
  setPermission(value);
};

export const handleSelectUnitCodeFunction = (setCodeUnit, value) => {
  setCodeUnit(value);
};

export const handleSelecTypeServiceFunction = (value, setTypeService) => {
  setTypeService(value);
};

export const handleSelecUnitfunction = (value, setTruck) => {
  setTruck(value);
};

export const handleSubmitFunction = (economicNumber, setSnackbar, truck, capacity, cargoInsurance, civilLiabilityInsurance, environmentalInsurance, plates, model, permissionSCT, license, compartmen,
  typeofService, permission, codeUnit, shipperTruckSelected, addshipperTruckMode, dispatch, addShipperTruck, handleClose, editShipperTruck, handleOpenValues) => {
  if (!economicNumber) {
    setSnackbar("Favor de ingresar un numero economico", "danger");
    return;
  }
  if (!truck) {
    setSnackbar("Favor de ingresar un Tipo de unidad", "danger");
    return;
  }
  if (!capacity) {
    setSnackbar("Favor de ingresar la capacidad", "danger");
    return;
  }
  if (!cargoInsurance) {
    setSnackbar("Favor de ingresar una carga", "danger");
    return;
  }
  if (!civilLiabilityInsurance) {
    setSnackbar("Favor de ingresar una responsabilidad", "danger");
    return;
  }
  if (!environmentalInsurance) {
    setSnackbar("Favor de ingresar un Medio ambiente", "danger");
    return;
  }
  if (!plates) {
    setSnackbar("Favor de ingresar placas", "danger");
    return;
  }
  if (!model) {
    setSnackbar("Favor de ingresar el modelo", "danger");
    return;
  }
  if (!permissionSCT) {
    setSnackbar("Favor de ingresar el Permiso SCT", "danger");
    return;
  }
  if (!license) {
    setSnackbar("Favor de ingresar una licencia", "danger");
    return;
  }
  if (!compartmen) {
    setSnackbar("Favor de ingresar un Compartimiento", "danger");
    return;
  }
  if (!typeofService) {
    setSnackbar("Favor de ingresar el Tipo de servicio", "danger");
    return;
  }
  if (!permission) {
    setSnackbar("Favor de ingresar un permiso de unidad", "danger");
    return;
  }
  if (!codeUnit) {
    setSnackbar("Favor de ingresar un Codigo de unidad", "danger");
    return;
  }

  const newValues = {
    ...shipperTruckSelected,
    type: truck,
    economicNumber,
    license,
    capacity: parseInt(capacity),
    plates,
    permissionSCT,
    model,
    permissionShipperTruck: permission,
    cargoInsurance,
    civilLiabilityInsurance,
    environmentalInsurance,
    compartmen: parseInt(compartmen),
    trailerCodeSAT: codeUnit,
    typeService: typeofService,
  };

  if (newValues.type.length > 0 && newValues.economicNumber.length > 0 && newValues.license.length > 0 &&
    newValues.capacity > 0 && newValues.plates.length > 0 && newValues.permissionSCT.length > 0 &&
    newValues.model.length > 0 && newValues.permissionShipperTruck.length > 0 && newValues.cargoInsurance.length > 0 &&
    newValues.civilLiabilityInsurance.length > 0 && newValues.environmentalInsurance.length > 0 && newValues.compartmen > 0 &&
    newValues.trailerCodeSAT.length > 0 && newValues.typeService.length > 0) {
    if (addshipperTruckMode) {
      dispatch(addShipperTruck(newValues));
      handleClose();
    } else {
      dispatch(editShipperTruck(shipperTruckSelected.id, newValues));
      handleClose();
    }
  } else {
    handleOpenValues();
  }
};

export const handleNewValuesFunction = (shipperTruckSelected, handleNewValues, setTruck, setPermission, setCodeUnit, setTypeService) => {
  if (shipperTruckSelected) {
    handleNewValues({
      economicNumber: shipperTruckSelected.economicNumber,
      license: shipperTruckSelected.license,
      capacity: shipperTruckSelected.capacity,
      gn3Indentifier: shipperTruckSelected.gn3Indentifier,
      plates: shipperTruckSelected.plates,
      permissionSCT: shipperTruckSelected.permissionSCT,
      model: shipperTruckSelected.model,
      vehicularConfiguration: shipperTruckSelected.vehicularConfiguration,
      cargoInsurance: shipperTruckSelected.cargoInsurance,
      civilLiabilityInsurance: shipperTruckSelected.civilLiabilityInsurance,
      environmentalInsurance: shipperTruckSelected.environmentalInsurance,
      compartmen: shipperTruckSelected.compartmen,
    });
    setTruck(shipperTruckSelected.type);
    setPermission(shipperTruckSelected.permissionShipperTruck);
    setCodeUnit(shipperTruckSelected.trailerCodeSAT);
    setTypeService(shipperTruckSelected.typeService);
  }
};
